// extracted by mini-css-extract-plugin
export default {"heading":"OIDCActivity-heading-39d87b8034997c6e9581edcc2235b913","chart":"OIDCActivity-chart-ae85a109d963530fea0fde62d23ae468"};